import '@formatjs/intl-segmenter/polyfill.js';

const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });

export const firstGrapheme = (str: string): string => {
    const first = segmenter.segment(str)[Symbol.iterator]().next();
    return first.done ? '' : first.value.segment;
};
